// src/utils/exportToCSV.js
import { saveAs } from 'file-saver';

export const exportToCSV = (branchName, punchTime) => {
  const csvData = `Branch Name,Punch Time\n"${branchName}","${punchTime}"\n`;
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, 'punchingdata.csv');
};
